module.exports = __webpack_public_path__ + "static/media/birthday-attack-card.05bee73c.wav";